import HormonalniDisruptor from "./HormonalniDisruptor";
import Karcinogen from "./Karcinogen";
import Zavrate from "./Zavrate";
import Zaludek from "./Zaludek";
import Listek from "./Listek";
import Mutagen from "./Mutagen";
import Oko1 from "./Oko1";
import Oko2 from "./Oko2";
import Plice1 from "./Plice1";
import Plice2 from "./Plice2";
import Plod from "./Plod";
import Postava from "./Postava";
import Prostredi from "./Prostredi";
import Ruka1 from "./Ruka1";
import Ruka2 from "./Ruka2";
import Ryba from "./Ryba";
import Sliznice from "./Sliznice";
import Tlapka from "./Tlapka";
import Kapka0 from "./Kapka0";
import Kapka1 from "./Kapka-1";
import Kapka2 from "./Kapka-1";

import * as React from "react";


export function getAllSentenceIconsKeys() {
    return [
        "alergie-1",
        "alergie-2",
        "bioacumulation-1",
        "bioacumulation-2",
        "breast_milk-1",
        "breast_milk-2",
        "danger-1",
        "danger-2",
        "fumes-1",
        "fumes-2",
        "heard-1",
        "heard-2",
        "hormonalni_disruptor-1",
        "hormonalni_disruptor-2",
        "imunity-1",
        "imunity-2",
        "invertebrates-1",
        "invertebrates-2",
        "karcinogen-1",
        "karcinogen-2",
        "listek+1",
        "listek+2",
        "microplastics-1",
        "microplastics-2",
        "mutagen-1",
        "mutagen-2",
        "nanomaterials-1",
        "nanomaterials-2",
        "oko1-1",
        "oko1-2",
        "oko2-1",
        "oko2-2",
        "ozon-1",
        "ozon-2",
        "pb-1",
        "pb-2",
        "plice1-1",
        "plice1-2",
        "plod-1",
        "plod-2",
        "postava-1",
        "postava-2",
        "prostredi-1",
        "prostredi-2",
        "ruka1-1",
        "ruka1-2",
        "ruka2-1",
        "ruka2-2",
        "ryba-1",
        "ryba-2",
        "sliznice-1",
        "sliznice-2",
        "tlapka+1",
        "tlapka+2",
        "zaludek-1",
        "zaludek-2",
        "zaludek2-2",
        "zavrate-1",
        "zavrate-2"
    ];
}


export default function getSentenceIconByKey(key, width = 60) {
                console.log("getSentenceIconByKey key:", key);

                const style = { width, height: width };

                switch (key) {
                    case "alergie-1":
                        return <img src={require("./icons/-1/Alergie-1.png")} style={style} alt="alergie-1" />;
                    case "alergie-2":
                        return <img src={require("./icons/-2/Alergie-2.png")} style={style} alt="alergie-2" />;
                    case "bioacumulation-1":
                        return <img src={require("./icons/-1/Bioacumulation-1.png")} style={style} alt="bioacumulation-1" />;
                    case "bioacumulation-2":
                        return <img src={require("./icons/-2/Bioacumulation-2.png")} style={style} alt="bioacumulation-2" />;
                    case "breast_milk-1":
                        return <img src={require("./icons/-1/Breast milk-1.png")} style={style} alt="breast_milk-1" />;
                    case "breast_milk-2":
                        return <img src={require("./icons/-2/Breast milk-2.png")} style={style} alt="breast_milk-2" />;
                    case "danger-1":
                        return <img src={require("./icons/-1/Danger-1.png")} style={style} alt="danger-1" />;
                    case "danger-2":
                        return <img src={require("./icons/-2/Danger-2.png")} style={style} alt="danger-2" />;
                    case "fumes-1":
                        return <img src={require("./icons/-1/Fumes-1.png")} style={style} alt="fumes-1" />;
                    case "fumes-2":
                        return <img src={require("./icons/-2/Fumes-2.png")} style={style} alt="fumes-2" />;
                    case "heard-1":
                        return <img src={require("./icons/-1/Heard-1.png")} style={style} alt="heard-1" />;
                    case "heard-2":
                        return <img src={require("./icons/-2/Heard-2.png")} style={style} alt="heard-2" />;
                    case "hormonalni_disruptor-1":
                        return <img src={require("./icons/-1/Hormonalni disruptor-1.png")} style={style} alt="hormonalni_disruptor-1" />;
                    case "hormonalni_disruptor-2":
                        return <img src={require("./icons/-2/Hormonalni disruptor-2.png")} style={style} alt="hormonalni_disruptor-2" />;
                    case "imunity-1":
                        return <img src={require("./icons/-1/Imunity-1.png")} style={style} alt="imunity-1" />;
                    case "imunity-2":
                        return <img src={require("./icons/-2/Imunity-2.png")} style={style} alt="imunity-2" />;
                    case "invertebrates-1":
                        return <img src={require("./icons/-1/Invertebrates-1.png")} style={style} alt="invertebrates-1" />;
                    case "invertebrates-2":
                        return <img src={require("./icons/-2/Invertebrates-2.png")} style={style} alt="invertebrates-2" />;
                    case "karcinogen-1":
                        return <img src={require("./icons/-1/Karcinogen-1.png")} style={style} alt="karcinogen-1" />;
                    case "karcinogen-2":
                        return <img src={require("./icons/-2/Karcinogen-2.png")} style={style} alt="karcinogen-2" />;
                    case "listek+1":
                        return <img src={require("./icons/+1/Listek.png")} style={style} alt="listek+1" />;
                    case "listek+2":
                        return <img src={require("./icons/+2/Listek.png")} style={style} alt="listek+2" />;
                    case "microplastics-1":
                        return <img src={require("./icons/-1/Microplastics-1.png")} style={style} alt="microplastics-1" />;
                    case "microplastics-2":
                        return <img src={require("./icons/-2/Microplastics-2.png")} style={style} alt="microplastics-2" />;
                    case "mutagen-1":
                        return <img src={require("./icons/-1/Mutagen-1.png")} style={style} alt="mutagen-1" />;
                    case "mutagen-2":
                        return <img src={require("./icons/-2/Mutagen-2.png")} style={style} alt="mutagen-2" />;
                    case "nanomaterials-1":
                        return <img src={require("./icons/-1/Nanomaterials-1.png")} style={style} alt="nanomaterials-1" />;
                    case "nanomaterials-2":
                        return <img src={require("./icons/-2/Nanomaterials-2.png")} style={style} alt="nanomaterials-2" />;
                    case "oko1-1":
                        return <img src={require("./icons/-1/Oko1-1.png")} style={style} alt="oko1-1" />;
                    case "oko1-2":
                        return <img src={require("./icons/-2/Oko1-2.png")} style={style} alt="oko1-2" />;
                    case "oko2-1":
                        return <img src={require("./icons/-1/Oko2-1.png")} style={style} alt="oko2-1" />;
                    case "oko2-2":
                        return <img src={require("./icons/-2/Oko2-2.png")} style={style} alt="oko2-2" />;
                    case "ozon-1":
                        return <img src={require("./icons/-1/Ozon-1.png")} style={style} alt="ozon-1" />;
                    case "ozon-2":
                        return <img src={require("./icons/-2/Ozon-2.png")} style={style} alt="ozon-2" />;
                    case "pb-1":
                        return <img src={require("./icons/-1/Pb-1.png")} style={style} alt="pb-1" />;
                    case "pb-2":
                        return <img src={require("./icons/-2/Pb-2.png")} style={style} alt="pb-2" />;
                    case "plice1-1":
                        return <img src={require("./icons/-1/Plice1-1.png")} style={style} alt="plice1-1" />;
                    case "plice1-2":
                        return <img src={require("./icons/-2/Plice1-2.png")} style={style} alt="plice1-2" />;
                    case "plod-1":
                        return <img src={require("./icons/-1/Plod-1.png")} style={style} alt="plod-1" />;
                    case "plod-2":
                        return <img src={require("./icons/-2/Plod-2.png")} style={style} alt="plod-2" />;
                    case "postava-1":
                        return <img src={require("./icons/-1/Postava-1.png")} style={style} alt="postava-1" />;
                    case "postava-2":
                        return <img src={require("./icons/-2/Postava-2.png")} style={style} alt="postava-2" />;
                    case "prostredi-1":
                        return <img src={require("./icons/-1/Prostredi-1.png")} style={style} alt="prostredi-1" />;
                    case "prostredi-2":
                        return <img src={require("./icons/-2/Prostredi-2.png")} style={style} alt="prostredi-2" />;
                    case "ruka1-1":
                        return <img src={require("./icons/-1/Ruka1-1.png")} style={style} alt="ruka1-1" />;
                    case "ruka1-2":
                        return <img src={require("./icons/-2/Ruka1-2.png")} style={style} alt="ruka1-2" />;
                    case "ruka2-1":
                        return <img src={require("./icons/-1/Ruka2-1.png")} style={style} alt="ruka2-1" />;
                    case "ruka2-2":
                        return <img src={require("./icons/-2/Ruka2-2.png")} style={style} alt="ruka2-2" />;
                    case "ryba-1":
                        return <img src={require("./icons/-1/Ryba-1.png")} style={style} alt="ryba-1" />;
                    case "ryba-2":
                        return <img src={require("./icons/-2/Ryba-2.png")} style={style} alt="ryba-2" />;
                    case "sliznice-1":
                        return <img src={require("./icons/-1/Sliznice-1.png")} style={style} alt="sliznice-1" />;
                    case "sliznice-2":
                        return <img src={require("./icons/-2/Sliznice-2.png")} style={style} alt="sliznice-2" />;
                    case "tlapka+1":
                        return <img src={require("./icons/+1/Tlapka.png")} style={style} alt="tlapka+1" />;
                    case "tlapka+2":
                        return <img src={require("./icons/+2/Tlapka.png")} style={style} alt="tlapka+2" />;
                    case "zaludek-1":
                        return <img src={require("./icons/-1/Zaludek-1.png")} style={style} alt="zaludek-1" />;
                    case "zaludek-2":
                        return <img src={require("./icons/-2/Zaludek-2.png")} style={style} alt="zaludek-2" />;
                    case "zaludek2-2":
                        return <img src={require("./icons/-2/Zaludek2-2.png")} style={style} alt="zaludek2-2" />;
                    case "zavrate-1":
                        return <img src={require("./icons/-1/Zavrate-1.png")} style={style} alt="zavrate-1" />;
                    case "zavrate-2":
                        return <img src={require("./icons/-2/Zavrate-2.png")} style={style} alt="zavrate-2" />;
                    default:
                        return <img src={require("./icons/-1/Mutagen-1.png")} style={style} alt="mutagen-1" />;
                }
            }


 function getSentenceIconByKeyOLD(key, width = 60) {
    switch (key) {
        case "hormonalniDisruptor":
            return <HormonalniDisruptor width={width} height={width}/>;
        case "karcinogen":
            return <Karcinogen width={width} height={width}/>;
        case "listek":
            return <Listek width={width} height={width}/>;
        case "mutagen":
            return <Mutagen width={width} height={width}/>;
        case "oko1":
            return <Oko1 width={width} height={width}/>;
        case "oko2":
            return <Oko2 width={width} height={width}/>;
        case "plice1":
            return <Plice1 width={width} height={width}/>;
        case "plice2":
            return <Plice2 width={width} height={width}/>;
        case "plod":
            return <Plod width={width} height={width}/>;
        case "postava":
            return <Postava width={width} height={width}/>;
        case "prostredi":
            return <Prostredi width={width} height={width}/>;
        case "ruka1":
            return <Ruka1 width={width} height={width}/>;
        case "ruka2":
            return <Ruka2 width={width} height={width}/>;
        case "ryba":
            return <Ryba width={width} height={width}/>;
        case "sliznice":
            return <Sliznice width={width} height={width}/>;
        case "tlapka":
            return <Tlapka width={width} height={width}/>;
        case "zaludek":
            return <Zaludek width={width} height={width}/>;
        case "zavrate":
            return <Zavrate width={width} height={width}/>;
        case "kapka0":
            return <Kapka0 width={width} height={width}/>;
        case "kapka-1":
            return <Kapka1 width={width} height={width}/>;
        case "kapka-2":
            return <Kapka2 width={width} height={width}/>;
        default:
            return <Mutagen width={width} height={width}/>;
    }
}